// import React from 'react';
// import { PaginationProps } from './typs';

// export const Pagination: React.FC<PaginationProps> = ({
// 	currentPage,
// 	totalPages,
// 	pageNumbers,
// 	setCurrentPage,
// }) => {
// 	return (
// 		<div className="flex items-center justify-between mt-4">
// 			<div className="flex flex-wrap gap-2">
// 				<button
// 					onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
// 					disabled={currentPage === 1}
// 					className="px-3 py-1 border rounded disabled:opacity-50"
// 				>
// 					Previous
// 				</button>
// 				{pageNumbers.map((number, i) => (
// 					<button
// 						key={i}
// 						onClick={() => setCurrentPage(number)}
// 						className={`px-3 py-1 border rounded ${
// 							currentPage === number ? 'bg-gray-800 text-white' : ''
// 						}`}
// 					>
// 						{number}
// 					</button>
// 				))}
// 				<button
// 					onClick={() =>
// 						setCurrentPage((prev) => Math.min(prev + 1, totalPages))
// 					}
// 					disabled={currentPage === totalPages}
// 					className="px-3 py-1 border rounded disabled:opacity-50"
// 				>
// 					Next
// 				</button>
// 			</div>
// 		</div>
// 	);
// };

import React from 'react';
import { PaginationProps } from './typs';

export const Pagination: React.FC<PaginationProps> = ({
	currentPage,
	totalPages,
	setCurrentPage,
}) => {
	const visiblePages = 5; // Number of pages to show at a time
	const startIndex = Math.max(
		Math.min(currentPage - 1, totalPages - visiblePages),
		0
	);

	const pageNumbers = Array.from(
		{ length: Math.min(visiblePages, totalPages) },
		(_, i) => i + 1 + startIndex
	);

	return (
		<div className="flex items-center justify-between mt-4">
			<div className="flex flex-wrap gap-2">
				{/* First Page Button */}
				<button
					onClick={() => setCurrentPage(1)}
					disabled={currentPage === 1}
					className="px-3 py-1 border rounded disabled:opacity-50"
				>
					{'<<'}
				</button>

				{/* Previous Button */}
				<button
					onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
					disabled={currentPage === 1}
					className="px-3 py-1 border rounded disabled:opacity-50"
				>
					{'<'}
				</button>

				{/* Page Numbers */}
				{pageNumbers.map((number) => (
					<button
						key={number}
						onClick={() => setCurrentPage(number)}
						className={`px-3 py-1 border rounded ${
							currentPage === number ? 'bg-[#324B69] text-white' : ''
						}`}
					>
						{number}
					</button>
				))}

				{/* Next Button */}
				<button
					onClick={() =>
						setCurrentPage((prev) => Math.min(prev + 1, totalPages))
					}
					disabled={currentPage === totalPages}
					className="px-3 py-1 border rounded disabled:opacity-50"
				>
					{'>'}
				</button>

				{/* Last Page Button */}
				<button
					onClick={() => setCurrentPage(totalPages)}
					disabled={currentPage === totalPages}
					className="px-3 py-1 border rounded disabled:opacity-50"
				>
					{'>>'}
				</button>
			</div>
		</div>
	);
};
